/**
 * Dummy file to ensure SonarQube analysis passes when no other .ts files are present.
 * This file can be safely deleted when real source files exist.
 */

export const sonarqubeDummy = true;